/**
 * DOM helper utilities
 */

/**
 * Create an element with className and optional attributes/children
 * @param {string} tag - HTML tag name
 * @param {string} [className] - CSS class name
 * @param {Object} [attrs] - Attributes to set
 * @param {(string|HTMLElement)[]} [children] - Child nodes or text
 * @returns {HTMLElement}
 */
export function createElement(tag, className, attrs, children) {
  const el = document.createElement(tag);
  if (className) el.className = className;
  if (attrs) {
    for (const [key, value] of Object.entries(attrs)) {
      if (key === 'style' && typeof value === 'object') {
        Object.assign(el.style, value);
      } else if (key.startsWith('on') && typeof value === 'function') {
        el.addEventListener(key.slice(2).toLowerCase(), value);
      } else {
        el.setAttribute(key, value);
      }
    }
  }
  if (children) {
    for (const child of children) {
      if (typeof child === 'string') {
        el.appendChild(document.createTextNode(child));
      } else if (child instanceof HTMLElement) {
        el.appendChild(child);
      }
    }
  }
  return el;
}

/**
 * Sanitize a string for safe DOM insertion (prevent XSS)
 * @param {string} str
 * @returns {string}
 */
export function escapeHtml(str) {
  const div = document.createElement('div');
  div.appendChild(document.createTextNode(str));
  return div.innerHTML;
}

/**
 * Remove all child nodes from element
 * @param {HTMLElement} el
 */
export function clearChildren(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
}
